import { useEffect, useState } from 'react'
import { getParams, isBrowser } from '../components/video-lib/utils/common'

export default function useParams() {
  const href = isBrowser() && window.location.href
  const params = (href && getParams(href)) || {}
  const [searchParams, setSearchParams] =
    useState<Record<string, string>>(params)

  useEffect(() => {
    if (href) {
      setSearchParams(getParams(href))
    }
  }, [href])

  return searchParams
}
